<template>
  <div class="player-games-container">
    <div class="base-info">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>基本信息</span>
        </div>
        <el-row>
          <el-col :span="5"><span><el-image :fit="'contain'" :src="player.smallProfile" :preview-src-list="[player.profile]" class="profile"/></span></el-col>
          <el-col :span="19">
            <div class="text item">
              <el-row>
                <el-col :span="12"><span>姓名: {{player.trueName}}</span></el-col>
                <el-col :span="12"><span>俱乐部: {{player.organizationName}}</span></el-col>
              </el-row>
            </div>
            <div class="text item">
              <el-row>
                <el-col :span="12"><span>性别: {{player.gender}}</span></el-col>
                <el-col :span="12"><span>生日: {{formatDate2(player.birthday)}}</span></el-col>
              </el-row>
            </div>
            <div class="text item">
              <el-row>
                <el-col :span="12"><span>国籍: {{player.nationality}}</span></el-col>
                <el-col :span="12"><span>籍贯: {{player.area}}</span></el-col>
              </el-row>
            </div>
            <div class="text item">
              <el-row>
                <el-col :span="12"><span>身高: {{player.high}}CM</span></el-col>
                <el-col :span="12"><span>体重: {{player.weight}}Kg</span></el-col>
              </el-row>
            </div>
            <div class="text item">
              <el-row>
                <el-col :span="12"><span>位置: {{player.position}}</span></el-col>
                <el-col :span="12"><span>号码: {{player.jerseyNo}}</span></el-col>
              </el-row>
            </div>
            <div class="text item">
              <el-row>
                <el-col :span="12"><span>持杆方式: {{player.stickHand}}</span></el-col>
                <el-col :span="12"><span>学校: {{player.school}}</span></el-col>
              </el-row>
            </div>
            <div class="text item">
              <el-row>
                <el-col :span="12"><span>年级: {{formatDate2(player.grade)}}</span></el-col>
                <el-col :span="12"><span>球队: {{player.team}}</span></el-col>
              </el-row>
            </div>
          </el-col>
        </el-row>
      </el-card>
    </div>
    <!-- 运动生涯 -->
    <div class="base-info">
      <el-card class="">
        <div slot="header" class="clearfix">
          <span>{{player.trueName}}冰球生涯年度统计</span>
        </div>
        <el-row>
          <el-col :span="24">
            <el-table
              v-loading="listLoading"
              :data="years"
              style="width: 100%">
              <el-table-column
                fixed
                prop="year"
                label="年度">
              </el-table-column>
              <el-table-column
                prop="gameCount"
                label="场数"
              >
              </el-table-column>
              <el-table-column
                prop="homeWin"
                label="主队胜场"
              >
              </el-table-column>
              <el-table-column
                prop="awayWin"
                label="客队胜场"
              >
              </el-table-column>
              <el-table-column
                prop="goalCount"
                label="进球"
              >
              </el-table-column>
              <el-table-column
                prop="assistCount"
                label="助攻"
              >
              </el-table-column>
              <el-table-column
                prop="shootoutCount"
                label="点球进球"
              >
              </el-table-column>
              <el-table-column
                prop="shootoutWinCount"
                label="点球制胜球"
              >
              </el-table-column>
              <el-table-column
                prop="plusCount"
                label="加时(min)"
              >
              </el-table-column>
              <el-table-column
                prop="plusGoalCount"
                label="加时进球"
              >
              </el-table-column>
              <el-table-column
                prop="penaltyCount"
                label="罚时(min)"
              >
              </el-table-column>
              <el-table-column
                prop="anyShootCount"
                label="射门"
              >
              </el-table-column>
              <el-table-column
                prop="eqCount"
                label="EQ"
              >
              </el-table-column>
              <el-table-column
                prop="enCount"
                label="EN"
              >
              </el-table-column>
              <el-table-column
                prop="p1Count"
                label="+1"
              >
              </el-table-column>
              <el-table-column
                prop="p2Count"
                label="+2"
              >
              </el-table-column>
              <el-table-column
                prop="m1Count"
                label="-1"
              >
              </el-table-column>
              <el-table-column
                prop="m2Count"
                label="-2"
              >
              </el-table-column>
              <el-table-column
                prop="psCount"
                label="PS"
              >
              </el-table-column>
              <el-table-column
                prop="gwgCount"
                label="GWG"
              >
              </el-table-column>
              <el-table-column
                prop="keepLoseCount"
                label="守丢数"
              >
              </el-table-column>
              <el-table-column
                prop="keepCount"
                label="守住数"
              >
              </el-table-column>
              <el-table-column
                prop="keepLoseWinCount"
                label="守丢至输"
              >
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </el-card>
    </div>
    <div class="base-info">
      <el-card class="">
        <div slot="header" class="clearfix">
          <span>{{player.trueName}}的赛事统计</span>
        </div>
        <el-row>
          <el-col :span="24">
            <el-table
              v-loading="listLoading"
              :data="matches"
              style="width: 100%">
              <el-table-column
                fixed
                width="300"
                label="赛事">
                <template slot-scope="scope">
                  <bjh-link :to="getPlayerMatchesRouter(scope.row)">{{scope.row.matchName}}</bjh-link>
                </template>
              </el-table-column>
              <el-table-column
                prop="gameCount"
                label="场数"
              >
              </el-table-column>
              <el-table-column
                prop="homeWin"
                label="主队胜场"
              >
              </el-table-column>
              <el-table-column
                prop="awayWin"
                label="客队胜场"
              >
              </el-table-column>
              <el-table-column
                prop="goal"
                label="进球"
              >
              </el-table-column>
              <el-table-column
                prop="assist"
                label="助攻"
              >
              </el-table-column>
              <el-table-column
                prop="shootoutGoal"
                label="点球进球"
              >
              </el-table-column>
              <el-table-column
                prop="shootoutWin"
                label="点球制胜球"
              >
              </el-table-column>
              <el-table-column
                prop="plusCount"
                label="加时(min)"
              >
              </el-table-column>
              <el-table-column
                prop="plusGoalCount"
                label="加时进球"
              >
              </el-table-column>
              <el-table-column
                prop="penalty"
                label="罚时(min)"
              >
              </el-table-column>
              <el-table-column
                prop="anyShoot"
                label="射门"
              >
              </el-table-column>
              <el-table-column
                prop="eq"
                label="EQ"
              >
              </el-table-column>
              <el-table-column
                prop="en"
                label="EN"
              >
              </el-table-column>
              <el-table-column
                prop="p1"
                label="+1"
              >
              </el-table-column>
              <el-table-column
                prop="p2"
                label="+2"
              >
              </el-table-column>
              <el-table-column
                prop="m1"
                label="-1"
              >
              </el-table-column>
              <el-table-column
                prop="m2"
                label="-2"
              >
              </el-table-column>
              <el-table-column
                prop="ps"
                label="PS"
              >
              </el-table-column>
              <el-table-column
                prop="gwg"
                label="GWG"
              >
              </el-table-column>
              <el-table-column
                prop="keepLose"
                label="守丢数"
              >
              </el-table-column>
              <el-table-column
                prop="keep"
                label="守住数"
              >
              </el-table-column>
              <el-table-column
                prop="shootoutLose"
                label="守丢至输"
              >
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </el-card>
    </div>
    <div class="base-info">
      <el-card class="">
        <div slot="header" class="clearfix">
          <span>{{player.trueName}}的球队统计</span>
        </div>
        <el-row>
          <el-col :span="24">
            <el-table
              v-loading="listLoading"
              :data="teams"
              style="width: 100%">
              <el-table-column
                fixed
                prop="teamName"
                label="球队"
                width="200">
                <template slot-scope="scope">
                  <bjh-link :to="getPlayerTeamsRouter(scope.row)">{{scope.row.teamName}}</bjh-link>
                </template>
              </el-table-column>
              <el-table-column
                prop="gameCount"
                label="场数"
              >
              </el-table-column>
              <el-table-column
                prop="homeWin"
                label="主队胜场"
              >
              </el-table-column>
              <el-table-column
                prop="awayWin"
                label="客队胜场"
              >
              </el-table-column>
              <el-table-column
                prop="goal"
                label="进球"
              >
              </el-table-column>
              <el-table-column
                prop="assist"
                label="助攻"
              >
              </el-table-column>
              <el-table-column
                prop="shootoutGoal"
                label="点球进球"
              >
              </el-table-column>
              <el-table-column
                prop="shootoutWin"
                label="点球制胜球"
              >
              </el-table-column>
              <el-table-column
                prop="plusCount"
                label="加时(min)"
              >
              </el-table-column>
              <el-table-column
                prop="plusGoalCount"
                label="加时进球"
              >
              </el-table-column>
              <el-table-column
                prop="penalty"
                label="罚时(min)"
              >
              </el-table-column>
              <el-table-column
                prop="anyShoot"
                label="射门"
              >
              </el-table-column>
              <el-table-column
                prop="eq"
                label="EQ"
              >
              </el-table-column>
              <el-table-column
                prop="en"
                label="EN"
              >
              </el-table-column>
              <el-table-column
                prop="p1"
                label="+1"
              >
              </el-table-column>
              <el-table-column
                prop="p2"
                label="+2"
              >
              </el-table-column>
              <el-table-column
                prop="m1"
                label="-1"
              >
              </el-table-column>
              <el-table-column
                prop="m2"
                label="-2"
              >
              </el-table-column>
              <el-table-column
                prop="ps"
                label="PS"
              >
              </el-table-column>
              <el-table-column
                prop="gwg"
                label="GWG"
              >
              </el-table-column>
              <el-table-column
                prop="keepLose"
                label="守丢数"
              >
              </el-table-column>
              <el-table-column
                prop="keep"
                label="守住数"
              >
              </el-table-column>
              <el-table-column
                prop="shootoutLose"
                label="守丢至输"
              >
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </el-card>
    </div>
    <!-- 历史比赛场次 -->
    <div class="base-info">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>{{player.trueName}}历年比赛统计</span>
        </div>
        <el-form :inline="true">
          <el-row>
            <el-form-item label="注册年度">
              <el-select v-model="yearIndex" placeholder="请选择" style="width:110px;" clearable @change="setYearTime">
                <el-option
                  v-for="(item, i) in membershipYears"
                  :key="i"
                  :label="item.year"
                  :value="i" />
              </el-select>
            </el-form-item>
            <el-form-item label="起止日期">
              <el-date-picker
                v-model="search.begin"
                type="date"
                placeholder="选择日期"
                @change="quickSearch"
              >
              </el-date-picker>
              <span>-</span>
              <el-date-picker
                v-model="search.end"
                type="date"
                placeholder="选择日期"
                @change="quickSearch"
              >
              </el-date-picker>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="赛事名称">
              <el-select v-model="search.matchName" @change="quickSearch('match')" placeholder="请选择" style="width:200px;" clearable>
                <el-option
                  v-for="(item, i) in matchList"
                  :key="i"
                  :label="item.name"
                  :value="item.name" />
              </el-select>
            </el-form-item>
            <el-form-item label="组别名称">
              <el-select v-model="search.groupName" @change="quickSearch('group')" placeholder="请选择" style="width:150px;" clearable>
                <el-option
                  v-for="(item, i) in groupList"
                  :key="i"
                  :label="item.name"
                  :value="item.name" />
              </el-select>
            </el-form-item>
            <el-form-item label="阶段名称">
              <el-select v-model="search.stageName" @change="quickSearch" placeholder="请选择" style="width:150px;" clearable>
                <el-option
                  v-for="(item, i) in stageList"
                  :key="i"
                  :label="item.name"
                  :value="item.name" />
              </el-select>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="比赛类型">
              <el-select
                style="width: 110px;"
                v-model="search.stageType" @change="quickSearch" placeholder="请选择" clearable>
                <el-option key="0" value="0" label="常规赛"/>
                <el-option key="1" value="1" label="季后赛"/>
              </el-select>
            </el-form-item>
            <el-form-item label="胜负关系">
              <el-select
                style="width: 110px;"
                v-model="search.win" @change="quickSearch" placeholder="请选择" clearable>
                <el-option key="1" value="1" label="胜"/>
                <el-option key="2" value="2" label="负"/>
                <el-option key="3" value="3" label="未知"/>
              </el-select>
            </el-form-item>
            <el-form-item label="球队名称">
              <el-input
                style="width: 200px;"
                v-model="search.teamName"
                @change="quickSearch"
                placeholder="请输入球队名称"/>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="EQ>=">
              <el-input
                style="width: 80px;"
                v-model="search.eq"
                @change="quickSearch"
                placeholder=""/>
            </el-form-item>
            <el-form-item label="EN>=">
              <el-input
                style="width: 80px;"
                v-model="search.en"
                @change="quickSearch"
                placeholder=""/>
            </el-form-item>
            <el-form-item label="+1>=">
              <el-input
                style="width: 80px;"
                v-model="search.p1"
                @change="quickSearch"
                placeholder=""/>
            </el-form-item>
            <el-form-item label="+2>=">
              <el-input
                style="width: 80px;"
                v-model="search.p2"
                @change="quickSearch"
                placeholder=""/>
            </el-form-item>
            <el-form-item label="-1>=">
              <el-input
                style="width: 80px;"
                v-model="search.m1"
                @change="quickSearch"
                placeholder=""/>
            </el-form-item>
            <el-form-item label="-2>=">
              <el-input
                style="width: 80px;"
                v-model="search.m2"
                @change="quickSearch"
                placeholder=""/>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="PS>=">
              <el-input
                style="width: 80px;"
                v-model="search.ps"
                @change="quickSearch"
                placeholder=""/>
            </el-form-item>
            <el-form-item label="GWG>=">
              <el-input
                style="width: 80px;"
                v-model="search.gwg"
                @change="quickSearch"
                placeholder=""/>
            </el-form-item>
            <el-form-item label="常规守丢数>=">
              <el-input
                style="width: 80px;"
                v-model="search.keepLose1"
                @change="quickSearch"
                placeholder=""/>
            </el-form-item>
            <el-form-item label="射门大战守丢数>=">
              <el-input
                style="width: 80px;"
                v-model="search.keepLose2"
                @change="quickSearch"
                placeholder=""/>
            </el-form-item>
            <el-form-item label="守住数>=">
              <el-input
                style="width: 80px;"
                v-model="search.keep"
                @change="quickSearch"
                placeholder=""/>
            </el-form-item>
          </el-row>
          <el-row align="center">
            <el-button type="primary" @click="quickSearch">查询</el-button>
          </el-row>
        </el-form>
      </el-card>
    </div>
    <!-- 比赛列表 -->
    <el-table
      v-loading="listLoading"
      :data="list">
      <el-table-column
        fixed
        label="赛事"
        width="300"
        prop="matchName"
      >
      </el-table-column>
      <el-table-column
        label="分组"
        prop="groupName"
      >
      </el-table-column>
      <el-table-column
        label="阶段"
        prop="stageName"
      >
      </el-table-column>
      <el-table-column
        label="场次"
        prop="seq"
      >
      </el-table-column>
      <el-table-column
        label="球队"
        prop="teamName"
      >
      </el-table-column>
      <el-table-column
        label="胜负"
      >
        <template slot-scope="scope">{{scope.row.win > 0 ? "胜" : (scope.row.lose > 0 ? "负" : "-")}}</template>
      </el-table-column>
      <el-table-column
        prop="goal"
        label="进球"
      >
      </el-table-column>
      <el-table-column
        prop="assist"
        label="助攻"
      >
      </el-table-column>
      <el-table-column
        prop="shootoutGoal"
        label="点球进球"
      >
      </el-table-column>
      <el-table-column
        prop="plusGoalCount"
        label="加时进球"
      >
      </el-table-column>
      <el-table-column
        prop="penalty"
        label="受罚"
      >
      </el-table-column>
      <el-table-column
        prop="penaltyMinute"
        label="罚时(min)"
      >
      </el-table-column>
      <el-table-column
        prop="eq"
        label="EQ"
      >
      </el-table-column>
      <el-table-column
        prop="en"
        label="EN"
      >
      </el-table-column>
      <el-table-column
        prop="p1"
        label="+1"
      >
      </el-table-column>
      <el-table-column
        prop="p2"
        label="+2"
      >
      </el-table-column>
      <el-table-column
        prop="m1"
        label="-1"
      >
      </el-table-column>
      <el-table-column
        prop="m2"
        label="-2"
      >
      </el-table-column>
      <el-table-column
        prop="ps"
        label="PS"
      >
      </el-table-column>
      <el-table-column
        prop="gwg"
        label="GWG"
      >
      </el-table-column>
      <el-table-column
        prop="keepLose1"
        label="常规守丢数"
      >
      </el-table-column>
      <el-table-column
        prop="keepLose2"
        label="射门大战守丢数"
      >
      </el-table-column>
      <el-table-column
        prop="keep"
        label="守住数"
      >
      </el-table-column>
    </el-table>
    <div class="table-footer">
      <el-pagination
        v-show="totalCount>0"
        @size-change="handleSizeChange"
        :current-page="currentPage"
        :page-size="pageSize"
        :total="totalCount"
        background
        layout="total, sizes, prev, pager, next"
        @current-change="handleCurrentChange">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import * as moment from 'moment'
import { ImageFormat } from '@/utils'
import { GetPlayerGamesDataList, GetPlayerYearsList, GetPlayerMatchesDataList, GetPlayerTeamsDataList } from '@/api/player'
import { getMemberShipYearList } from '@/api/site'
import { getClientMatchList, getClientGroupList, getClientStageList } from '@/api/match'

export default {
  name: 'PlayerGamesList',
  data() {
    return {
      search: {
        matchName:null,
        groupName:null,
        stageName:null,
        teamName:null,
        eq:null,
        en:null,
        p1:null,
        p2:null,
        m1:null,
        m2:null,
        ps:null,
        gwg:null,
        assist:null,
        keep:null,
        keepLose1:null,
        keepLose2:null,
        begin:null,
        end:null,
        win:null
      },
      membershipYears:[],
      yearIndex: null,
      activeName: 'first',
      list: [],
      years:[],
      matches:[],
      teams:[],
      latestYears: [],
      yearsTotal:null,
      totalCount: 0, // 默认数据总数
      pageSize: 10, // 每页的数据条数
      currentPage: 1, // 默认开始页面
      listQuery: {},
      playerId:null,
      listLoading: true,
      player:{
        smallProfile:'http://image.bjh.snsports.cn/Fn8CbV2swfbWFyuYHsQyfEtp4JwB',
        profile:'http://image.bjh.snsports.cn/Fn8CbV2swfbWFyuYHsQyfEtp4JwB',
        smallImage:'http://image.bjh.snsports.cn/Fn8CbV2swfbWFyuYHsQyfEtp4JwB',
        bigImage:'http://image.bjh.snsports.cn/Fn8CbV2swfbWFyuYHsQyfEtp4JwB',
        smallBackImage:'http://image.bjh.snsports.cn/Fn8CbV2swfbWFyuYHsQyfEtp4JwB',
        bigBackImage:'http://image.bjh.snsports.cn/Fn8CbV2swfbWFyuYHsQyfEtp4JwB'
      },
      matchList: [],
      groupList: [],
      stageList: []
    }
  },
  created() {
    this.playerId = this.$route.query.playerId
    if(this.$route.query.teamName) {
      this.search.teamName = this.$route.query.teamName
    }
    if(this.$route.query.matchName) {
      this.search.matchName = this.$route.query.matchName
    }
    if(this.$route.query.matchId) {
      this.getClientGroupList(this.$route.query.matchId)
    }
    this.getMembershipYear()
    this.getList()
    this.getYearsList()
    this.getMatchesList()
    this.getTeamsList()
    this.getClientMatchList()
  },
  mounted() {},
  methods: {
    getList(){
      this.listLoading = true
      this.listQuery = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        playerId: this.playerId
      }
      this.listQuery = Object.assign(this.listQuery, this.search)
      GetPlayerGamesDataList(this.listQuery).then(resolve=>{
        const data = resolve.data
        this.list = data.list
        this.currentPage = data.pageNum
        this.totalCount = data.count
        this.listLoading = false
        let player = data.player
        player.smallProfile = this.ImageFormats(player.profile, 150)
        player.profile = this.ImageFormats(player.profile, 1000)
        player.smallImage = this.certImageFormats(player.certificateFrontImg, 150, 94)
        player.bigImage = this.certImageFormats(player.certificateFrontImg, 1000, 1000)
        player.smallBackImage = this.certImageFormats(player.certificateBackImg, 150, 94)
        player.bigBackImage = this.certImageFormats(player.certificateBackImg, 1000, 1000)
        this.player = player
      })
    },
    getPlayerMatchesRouter(row){
      return {path: `/player-games-list2?playerId=${this.playerId}&matchName=${row.matchName}&matchId=${row.id}`}
    },
    getPlayerTeamsRouter(row){
      return {path: `/player-games-list2?playerId=${this.playerId}&teamName=${row.teamName}`}
    },
    getYearsList(){
      GetPlayerYearsList({playerId:this.playerId}).then(resolve=>{
        const data = resolve.data
        const years =data.years
        const len = years.length
        if (len > 1) {
          this.latestYears = [years[0], years[len - 1]]
        } else if (len == 1) {
          this.latestYears = years
        } else {
          this.latestYears = []
        }
        this.years = years
        this.yearsTotal = data.total
      })
    },
    getMatchesList(){
      GetPlayerMatchesDataList({playerId:this.playerId,pageSize:1000}).then(resolve=>{
        const data = resolve.data
        this.matches =data.list
      })
    },
    getTeamsList(){
      GetPlayerTeamsDataList({playerId:this.playerId,pageSize:1000}).then(resolve=>{
        const data = resolve.data
        this.teams = data.list
      })
    },
    setYearTime(){
      if(this.yearIndex === 0 || this.yearIndex) {
        const item = this.membershipYears[this.yearIndex]
        this.search.begin = item.membershipBeginDate//moment(item.membershipBeginDate).format('YYYY-MM-DD')
        this.search.end = item.membershipEndDate//moment(item.membershipEndDate).format('YYYY-MM-DD')
      } else {
        this.search.begin = null;
        this.search.end = null;
      }
      this.getList()
    },
    getMembershipYear(){
      getMemberShipYearList({all:1}).then(resolve=>{
        const data = resolve.data
        this.membershipYears = data.list
      })
    },
    getClientMatchList(){
      getClientMatchList().then(resolve=>{
        const data = resolve.data
        this.matchList = data.list
      })
    },
    getClientGroupList(matchId){
      const params = {
        matchId: matchId,
        stageType: this.search.stageType || 0
      }
      getClientGroupList(params).then(resolve=>{
        const data = resolve.data
        this.groupList = data.list
        this.stageList = []
      })
    },
    getClientStageList(groupId){
      const params = {
        groupId: groupId
      }
      getClientStageList(params).then(resolve=>{
        const data = resolve.data
        this.stageList = data.list
      })
    },
    handleClick() {},
    handleSizeChange(val) {
      this.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.$router.push({path: this.$route.path, query: {page: val}})
      this.currentPage = val
      this.getList()
    },
    quickSearch(name) {
      if (name === 'match' && this.search.matchName) {
        const match = this.matchList.find(item => item.name === this.search.matchName)
        this.getClientGroupList(match.id)
      } else if (name === 'group' && this.search.groupName) {
        const group = this.groupList.find(item => item.name === this.search.groupName)
        this.getClientStageList(group.id)
      }
      this.getList()
    },
    ImageFormats(img) {
      return ImageFormat.squareImageView(img, 100, 2)
    },
    certImageFormats(img, w, h) {
      img = img || 'Fn8CbV2swfbWFyuYHsQyfEtp4JwB'
      return ImageFormat.imageView(img, w, h)
    },
    formatCertType(type) {
      const t = parseInt(type)
      return t === 1 ? "身份证" : (t === 2 ? "护照" : (t === 3 ? "出生证" : (t === 4 ? "驾照" : "-")))
    },
    formatDate2: function(date) {
      return date && moment(date).format('YYYY-MM-DD')
    }
  },
  filters: {
    ImageFormats(img) {
      return ImageFormat.squareImageView(img, 100, 2)
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
.player-games-container {
  margin: 30px 15px;
  .base-info {
    margin-bottom: 20px;
    .box-card {
      width: 1000px;
      .item {
        padding: 10px 0;
        .title-box {
          font-size: 16px;
          font-weight: 400;
          padding: 6px 0;
        }
        .content-box {
          font-size: 14px;
          font-weight: 400;
          padding: 6px 0;
        }
      }
      .export-btn {
        position: absolute;
        top: 0;
        left: 220px;
      }
      .el-divider {
        margin: 10px 0;
      }
    }
  }
  .action-header {
    padding: 0 10px 10px 10px;
  }
  .el-table {
    th {
      div {
        line-height: 20px;
      }
      .el-select {
        padding-left: 0;
        padding-right: 0;
        .el-input {
          padding-left: 0;
          padding-right: 0;
        }
      }
    }
    th>{
      .cell {
        text-overflow: clip;
      }
    }
  }

  .table-footer {
    text-align: center;
    margin-top: 30px;
  }
}
.type-count {
  text-align: center;
}
.profile{
  display: inline-block;
  width: 106px;
  height: 144px;
}
.cert{
  display: inline-block;
  height: 94px;
  width: 150px;
}
.info{
  padding: 0 0 4px 0;
}
</style>
